import dotenv from 'dotenv';
import { BaseLLM, BaseLLMConfig } from './base-llm';

dotenv.config({ quiet: true });

export interface GeminiLLMConfig extends BaseLLMConfig {}

/**
 * GeminiLLM class for handling AI-powered component generation and matching using Google Gemini
 */
export class GeminiLLM extends BaseLLM {
	constructor(config?: GeminiLLMConfig) {
		super(config);
	}

	protected getDefaultModel(): string {
		return 'gemini/gemini-2.5-flash';
	}

	protected getDefaultFastModel(): string {
		// Gemini Flash is already fast/cheap, use the same
		return 'gemini/gemini-2.5-flash';
	}

	protected getDefaultApiKey(): string | undefined {
		return process.env.GEMINI_API_KEY;
	}

	protected getProviderName(): string {
		return 'Gemini';
	}
}

// Export a singleton instance
export const geminiLLM = new GeminiLLM();
